import apiClient from './apiClient';
import { 
  ChatMessageDeletionHistory, 
  ChatMessageDeletionHistoryListResponse, 
  ChatMessageDeletionHistorySearchParams 
} from '../types/chatMessageDeletionHistory';

// 外部データベースのAPIエンドポイント
const BASE_URL = '/external/chat_message_deletion_histories';

// レスポンスを処理する関数
const processResponse = (data: any): ChatMessageDeletionHistoryListResponse => {
  // レスポンスがページネーション形式の場合
  if (data && ('results' in data)) {
    return data;
  } 
  // 配列の場合（ページネーションなし）
  else if (Array.isArray(data)) {
    const histories = data as ChatMessageDeletionHistory[];
    return {
      count: histories.length,
      next: null,
      previous: null,
      results: histories
    };
  }
  // その他の形式
  else {
    console.warn('不明なレスポンス形式:', data);
    return {
      count: 0,
      next: null,
      previous: null,
      results: []
    };
  }
};

// チャットメッセージ削除履歴一覧を取得
export const getChatMessageDeletionHistories = async (
  params: ChatMessageDeletionHistorySearchParams = {}
): Promise<ChatMessageDeletionHistoryListResponse> => {
  try {
    // パラメータを加工
    const queryParams = { ...params };
    
    // room_typeが配列の場合、Django-rest-framework対応の形式に変換
    if (queryParams.room_type && Array.isArray(queryParams.room_type) && queryParams.room_type.length > 0) {
      // 複数選択の場合、Django-filter用にカンマ区切りの文字列に変換（room_type__in=value1,value2,value3の形式）
      queryParams.room_type__in = queryParams.room_type.join(',');
      // 元の room_type パラメータを削除
      delete queryParams.room_type;
    }

    try {
      // 通常のパラメータ処理
      const response = await apiClient.get<ChatMessageDeletionHistoryListResponse>(BASE_URL, { 
        params: queryParams,
      });
      return processResponse(response.data);
    } catch (error) {
      // エラーがページネーションに関連する場合は、ページをリセットして再試行
      const retryParams = { ...queryParams, page: 1 };
      const retryResponse = await apiClient.get<ChatMessageDeletionHistoryListResponse>(BASE_URL, { 
        params: retryParams
      });
      return processResponse(retryResponse.data);
    }
  } catch (error) {
    console.error('チャットメッセージ削除履歴取得エラー:', error);
    throw error;
  }
};

// チャットメッセージ削除履歴詳細を取得
export const getChatMessageDeletionHistory = async (id: number): Promise<ChatMessageDeletionHistory> => {
  const response = await apiClient.get<ChatMessageDeletionHistory>(`${BASE_URL}/${id}/`);
  return response.data;
};

const chatMessageDeletionHistoriesApi = {
  getChatMessageDeletionHistories,
  getChatMessageDeletionHistory
};

export default chatMessageDeletionHistoriesApi;